import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useRef } from '@redneckz/uni-jsx/lib/hooks';
import { useResizeObserver } from '../../hooks/useResizeObserver.js';
export const FoldableSection = JSX(({ className = '', isUnfolded, children }) => {
    const containerRef = useRef(null);
    const childrenWrapperRef = useResizeObserver((childrenWrapperEl) => {
        if (containerRef.current) {
            containerRef.current.style.maxHeight = isUnfolded
                ? `${childrenWrapperEl.scrollHeight}px`
                : '';
        }
    }, [isUnfolded]);
    return (_jsx("div", { ref: containerRef, className: `transition-max-h duration-300 overflow-hidden ${containerRef.current || !isUnfolded ? 'max-h-0' : ''} `, children: _jsx("div", { className: className, ref: childrenWrapperRef, children: children }) }));
});
//# sourceMappingURL=FoldableSection.js.map